var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3886 10.9792H20.5414V3.86806C20.5405 2.92535 20.1795 2.02153 19.5377 1.35494C18.8958 0.688346 18.0256 0.313441 17.1179 0.3125H14.6837C14.135 0.314919 13.6052 0.521563 13.1907 0.894931C12.7761 1.2683 12.5041 1.78365 12.4241 2.34746L11.4598 9.3602L7.3778 15.7199H0V32.3125H23.965C26.0829 32.31 28.1134 31.4351 29.6109 29.8798C31.1085 28.3245 31.9509 26.2157 31.9533 24.0162V15.7199C31.9518 14.4631 31.4704 13.2582 30.6147 12.3694C29.759 11.4807 28.5988 10.9807 27.3886 10.9792ZM6.84715 29.9421H2.28238V18.0903H6.84715V29.9421ZM29.671 24.0162C29.6692 25.5873 29.0674 27.0935 27.9977 28.2044C26.928 29.3153 25.4778 29.9402 23.965 29.9421H9.12953V17.2642L13.6464 10.2278L14.6848 2.68287H17.1179C17.4205 2.68287 17.7108 2.80774 17.9248 3.03C18.1388 3.25227 18.2591 3.55373 18.2591 3.86806V13.3495H27.3886C27.9936 13.3505 28.5736 13.6005 29.0015 14.0448C29.4293 14.4892 29.6701 15.0915 29.671 15.7199V24.0162Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.fdb19bafcc25387583bb14c89bd6ac07.svg";
export { ForwardRef as ReactComponent };